import { render, staticRenderFns } from "./ConsultarTicket.vue?vue&type=template&id=5fc11e6c"
import script from "./ConsultarTicket.vue?vue&type=script&lang=js"
export * from "./ConsultarTicket.vue?vue&type=script&lang=js"
import style0 from "./ConsultarTicket.vue?vue&type=style&index=0&id=5fc11e6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports